import React from "react";
import { Skeleton, Box, Typography } from '@mui/material';

const LoadingSkeleton = () => (
    <Box sx={{ pt: 1, pb: 1, pl: 3, pr: 3,bgcolor: '#f9f9f9' }}>
        <Box
            sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 2,
                boxShadow: 1,
                maxWidth: '100%',
                mx: 'auto',
            }}
        >
            {/* Section Title */}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                Loading...
            </Typography>

            {/* Filters */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Skeleton variant="rounded" width={120} height={40} sx={{ mr: 2 }} />
                <Skeleton variant="rounded" width={100} height={40} />
            </Box>

            {/* Headers */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1.5fr 2fr 2fr 1fr 1.5fr 2fr 0.5fr',
                    bgcolor: '#f0f0f0',
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                }}
            >
                <Typography variant="body2" fontWeight={600}></Typography>
            </Box>

            {/* Placeholder Rows */}
            {Array.from({ length: 6 }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1.5fr 2fr 2fr 1fr 1.5fr 2fr 0.5fr',
                        px: 2,
                        py: 1.5,
                        borderBottom: '1px solid #e0e0e0',
                        alignItems: 'center',
                    }}
                >
                    <Skeleton variant="text" width="90%" height={24} />
                    <Skeleton variant="text" width="100%" height={24} />
                    <Skeleton variant="text" width="100%" height={24} />
                    <Skeleton variant="text" width="80%" height={24} />
                    <Skeleton variant="text" width="100%" height={24} />
                    <Skeleton variant="text" width="80%" height={24} />
                </Box>
            ))}
        </Box>
    </Box>
);

export default LoadingSkeleton;
